import {Navigate} from "react-router-dom";
import {appPagePaths} from "services/navigation";
import type {AppProtectedPageProps} from "./PageProtectorBase.types";

export const PageProtectorBase = (props: AppProtectedPageProps) => {
  const {condition, to = appPagePaths.authorization, ...navigatePropsRest} = props;

  return condition ? <>{props.children}</> : <Navigate to={to} replace {...navigatePropsRest}/>;
};